export const projectAtmosphericLogsSelector = ({ rocketDry: { projectAtmosphericLogs: value = [] } }) => value;
export const projectEquipmentListSelector = ({ rocketDry: { projectEquipmentList: value = [] } }) => value;
export const externalAtmosphericLogsCreatedSelector = ({
  rocketDry: { externalAtmosphericLogsCreated: value = false },
}) => value;
export const externalAtmosphericLogsUpdatedSelector = ({
  rocketDry: { externalAtmosphericLogsUpdated: value = false },
}) => value;
export const externalAtmosphericLogsDeletedSelector = ({
  rocketDry: { externalAtmosphericLogsDeleted: value = false },
}) => value;
export const createExternalAtmosphericLogErrorsSelector = ({
  rocketDry: { createExternalAtmosphericLogErrors: value = [] },
}: any) => value;
